import React from "react";
import RichTextContent from "../../Helper/RichTextContent";
import {
  resolveMediaUrl,
  handleMediaImgError,
} from "../../Helper/mediaUrl";

/**
 * Published project updates / announcements list.
 */
function ProjectUpdates({ updates = [] }) {
  const list = Array.isArray(updates) ? updates : [];
  if (!list.length) {
    return null;
  }

  return (
    <section
      className="project-updates"
      aria-labelledby="project-updates-heading"
    >
      <h2 id="project-updates-heading" className="project-section-heading">
        Updates
      </h2>
      <ul className="project-updates__list">
        {list.map((item) => (
          <li key={item.id || item.title} className="project-updates__item">
            <p className="project-updates__meta">
              {(item.update_type || "news").replace(/^\w/, (c) =>
                c.toUpperCase()
              )}
              {item.published_at
                ? ` · ${new Date(item.published_at).toLocaleDateString()}`
                : ""}
            </p>
            <h3 className="project-updates__title">{item.title}</h3>
            {item.body ? (
              <RichTextContent
                html={item.body}
                className="project-updates__body rich-text--on-light"
              />
            ) : null}
            {item.media_url ? (
              <img
                src={resolveMediaUrl(item.media_url)}
                alt=""
                className="project-updates__media"
                onError={handleMediaImgError}
              />
            ) : null}
          </li>
        ))}
      </ul>
    </section>
  );
}

export default ProjectUpdates;
